import { urlsWrapper } from 'config';
import {
  saveData,
  createCommonListConstants,
  createCommonListReducer,
} from './utils';
import { commonDelete, commonPost, commonPut } from './api';

const constants = createCommonListConstants('MARKERS');

// reducer
export default createCommonListReducer(constants);

// actions
export function getMarkers() {
  return saveData(
    `${urlsWrapper('markers')}`,
    constants.SET_LIST,
    constants.SET_IS_PENDING
  );
}

export const deleteMarker = (markerId) => () =>
  commonDelete({ url: `${urlsWrapper('markers')}/${markerId}` });

export const addMarker = (data) => () =>
  commonPost({ url: `${urlsWrapper('markers')}`, data });

export const updateMarker = (markerId, data) => () =>
  commonPut({
    url: `${urlsWrapper('markers')}/${markerId}`,
    data,
    name: 'метку',
  });

// selector
export const getMarkerSelector = (state) => state.markers.list;
